import { useState } from "react";
import { getVendor, createVendor, getVendorById , updateVendor, getVendorProduct, addVendorProduct, deleteVendorProduct, deleteVendor} from "../../../Services/VendorServices";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import toast from "react-hot-toast";
import { TOAST_MESSAGES } from "../constants";

export const useVendor = () => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({
    search: null,
    product: null,
  });

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchAllVendors = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getVendor({
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ...params,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.VENDOR_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.VENDOR_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

    const fetchVendorById = async (id) => {
        setLoading(true);
        var data = null;
        try {
            const response = await getVendorById(id);
            if (response.status === 200) {
                data = response.data;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.VENDOR_FETCH_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.VENDOR_FETCH_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const newVendor = async (payload) => {
        setLoading(true);
        var data = null;
        try {
            const response = await createVendor(payload);
            if (response.status === 201) {
                data = response.data;
                const msg = TOAST_MESSAGES.VENDOR_SUCCESS;
                toast.success(msg);
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.VENDOR_CREATE_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.VENDOR_CREATE_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const updateVendorDetails = async (VendorId, payload) => {
        setLoading(true);
        var data = null;
        try {
            const response = await updateVendor(VendorId, payload);
            if (response.status === 200) {
                data = response.data;
                const msg = TOAST_MESSAGES.UPDATE_VENDOR_SUCCESS;
                toast.success(msg);
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.UPDATE_VENDOR_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_VENDOR_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
  };
  
  const fetchVendorProduct = async (vendorId) => {
    setLoading(true);
    try {
      const response = await getVendorProduct(vendorId);

      if (response.status === 200) {
        return response.data.results
      } else {
        toast.error(TOAST_MESSAGES.FAILED_FETCH_PRODUCT);
        return null;
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_FETCH_PRODUCT
      );
    } finally {
      setLoading(false);
    }
  };

  const addVendorProducts = async (vendorId, payload) => {
    setLoading(true);
    let data = null;
    try {
      const response = await addVendorProduct(vendorId, payload);
      if (response.status === 201) {
        data = response.data;
        // toast.success(TOAST_MESSAGES.VENDOR_PRODUCT_SUCCESS);
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.VENDOR_PRODUCT_CREATE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.VENDOR_PRODUCT_CREATE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteVendorProducts = async (vendorId, productId) => {
    setLoading(true);
    let success = false;
    try {
      const response = await deleteVendorProduct(vendorId, productId);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.VENDOR_PRODUCT_DELETE_SUCCESS);
        success = true;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.VENDOR_PRODUCT_DELETE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) ||
        TOAST_MESSAGES.VENDOR_PRODUCT_DELETE_FAILED
      );
    } finally {
      setLoading(false);
      return success;
    }
  };

  const removeVendor = async (id) => {
    setLoading(true);
    let success = false;
    try {
      const response = await deleteVendor(id);
      if (response.status === 204 || response.status === 200) {
        toast.success(TOAST_MESSAGES.DELETE_VENDOR_SUCCESS);
        success = true;
      } else {
        toast.error(
          extractErrorMessage(response) || TOAST_MESSAGES.DELETE_VENDOR_FAILED
        );
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.DELETE_VENDOR_ERROR
      );
    } finally {
      setLoading(false);
      return success;
    }
  };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    filters,
    setFilters,
    onPageChange,
    onPageSizeChange,
    fetchAllVendors,
    fetchVendorById,
    newVendor,
    updateVendorDetails,
    fetchVendorProduct,
    addVendorProducts,
    deleteVendorProducts,
    removeVendor
  };
};
